//console.log("custom.js");
function RenderCartSlider() {
  
  console.log("cart_rec_slider");
  if (document.querySelector(".cart_rec_slider")) {
    const pdpUpsellsSwiper = new Swiper(".cart_rec_slider", {
      slidesPerView: 3,
      spaceBetween: 10, // You can adjust this for spacing between slides
      loop: false, // Equivalent to infinite scrolling
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        400: {
          slidesPerView: 3,
        },
        576: {
          slidesPerView: 3,
        },
        610: {
          slidesPerView: 4,
        },
      },
    });
    document.querySelector(".cart_rec_slider").style.opacity = 1;
  }
}

function RenderPreOrder(preOrderElement, preOrderButton) {
  //console.log("RenderPreOrder");
  if (!preOrderElement) return;
  const dataUrl = preOrderElement.getAttribute("data-url");

  if (dataUrl) {
    fetch(dataUrl)
      .then((response) => response.json())
      .then((data) => {
        // Store response in a variable
        let jsonResponsePreOrder = data;

        let PreOrderVariant = jsonResponsePreOrder.variants.find(
          (variant) => variant.title == document.querySelector(".seletect-variant-id").getAttribute("data-title")
        );
        document.querySelector('.custom-pre-order [name="id"]').value = PreOrderVariant.id;

        if (preOrderButton) {
          preOrderButton.addEventListener("click", function () {
            document.querySelector('form.custom-pre-order button[type="submit"]').click();
          });
        }

        // You can use jsonResponse as needed here
      })
      .catch((error) => console.error("Error fetching data:", error));
  }
}

function RenderCollectionslider() {
  if (document.querySelector(".collectionSwiper")) {
    //console.log("RenderCollectionslider");
    const varientSlider = new Swiper(".collectionSwiper", {
      slidesPerView: 1,
      speed: 500,
      delay: 100,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
}

function RederSateches() {
  // JavaScript to handle the click event for mobile_quickbuy_trigger
  document.querySelectorAll(".mobile_quickbuy_trigger").forEach(function (trigger) {
    trigger.addEventListener("click", function () {
      this.closest(".product-card").classList.add("quickbuy-active");
    });
  });

  // JavaScript to handle the click event for mobile_quickbuy_trigger
  document.querySelectorAll(".close_button").forEach(function (trigger) {
    trigger.addEventListener("click", function () {
      this.closest(".product-card").classList.remove("quickbuy-active");
    });
  });

  // Function to check screen width
  function isScreenAbove700px() {
    return window.innerWidth > 700;
  }

  // Get all product cards
  var productCards = document.querySelectorAll(".product-card");

  // Iterate through each product card
  productCards.forEach(function (card) {
    var figure = card.querySelector(".product-card__figure");
    var swatches = card.querySelector(".swatches_kopstorm");
    if (!figure) return;
    // Function to handle hover in
    function handleHoverIn() {
      if (isScreenAbove700px()) {
        swatches.style.display = "block";
      }
    }

    // Function to handle hover out
    function handleHoverOut() {
      if (isScreenAbove700px()) {
        swatches.style.display = "none";
      }
    }

    // Add event listener for hover in
    figure.addEventListener("mouseover", handleHoverIn);

    // Add event listener for hover out
    figure.addEventListener("mouseout", handleHoverOut);
  });
}

function RenderTagLinks() {
  const facetform = document.querySelectorAll("facets-form form");
  document.querySelectorAll(".collection_product_tags a").forEach((taglink) => {
    taglink.addEventListener("click", (e) => {
      e.preventDefault();
      if (facetform) {
        facetform.forEach((form) => {
          form.setAttribute("action", taglink.getAttribute("href"));
        });
      }
      const checkbox = document.querySelector('[name="filter.v.availability"]');

      if (checkbox) {
        // checkbox.checked = false; // Toggle or set true/false
        checkbox.dispatchEvent(new Event("change", {bubbles: true}));
      }
    });
  });
}
document.addEventListener("DOMContentLoaded", function (event) {
  //console.log("DOM fully loaded and parsed");

  RenderCollectionslider();
  RederSateches();
  RenderTagLinks();
  RenderCartSlider();
  setTimeout(function () {
    RederSateches();
  }, 3000);

  document.addEventListener("cart:refresh", (event) => {
    console.log("cart:refresh");
    setTimeout(function () {
      RenderCartSlider();
    }, 200);
  });
  document.addEventListener("cart:change", (event) => {
    console.log("cart:change");
    setTimeout(function () {
      RenderCartSlider();
    }, 200);
  });
  document.addEventListener("cart:prepare-bundled-sections", (event) => {
    console.log("cart:prepare-bundled-sections");
    setTimeout(function () {
      RenderCartSlider();
    }, 200);
  });

  if (document.querySelector(".varient_slider")) {
    const varientSlider = new Swiper(".varient_slider", {
      slidesPerView: 6.5, // Default for mobile
      spaceBetween: 3,
      freeMode: true, // Enables free scrolling
      freeModeMomentum: true, // Adds momentum for natural feel
      freeModeMomentumRatio: 1, // Controls momentum strength
      freeModeMomentumVelocityRatio: 0.5, // Controls speed of momentum
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        // Tablet and up: maintain your original settings
        768: {
          slidesPerView: 7.5,
          spaceBetween: 5,
          freeMode: false, // Disable free mode on larger screens
        },
        992: {
          slidesPerView: 8.5,
          spaceBetween: 5,
          freeMode: false,
        },
        1200: {
          slidesPerView: 8.5,
          spaceBetween: 5,
          freeMode: false,
        },
      },
      // Optional: Disable navigation buttons on mobile if not needed
      on: {
        init: function () {
          if (window.innerWidth < 768) {
            //this.navigation.destroy();
          }
        },
        resize: function () {
          if (window.innerWidth < 768) {
            // this.navigation.destroy();
          } else {
            // this.navigation.init();
          }
        },
      },
    });

    // Get all slides as an array
    const slides = Array.from(varientSlider.slides);

    // Sort slides based on data-index attribute
    slides.sort((a, b) => {
      const indexA = parseInt(a.getAttribute("data-index")) || 6;
      const indexB = parseInt(b.getAttribute("data-index")) || 6;
      return indexA - indexB; // Ascending order (use indexB - indexA for descending)
    });

    // Remove all existing slides
    varientSlider.removeAllSlides();

    // Append sorted slides
    slides.forEach((slide) => varientSlider.appendSlide(slide));

    // Update Swiper to reflect changes
    varientSlider.update();

    document.querySelector(".cust_swatches").removeAttribute("style");
    const activeSlideIndex = Array.from(document.querySelectorAll(".varient_slider .swiper-slide")).findIndex((slide) =>
      slide.classList.contains("activeslide")
    );
    //varientSlider.slideTo(activeSlideIndex);
  }

  let preOrderElement = document.querySelector(".custom-pre-order");

  const addToCartButton = document.querySelector('product-form button[type="submit"]');
  document.addEventListener("variant:change", function (event) {
    let preOrderButton = document.querySelector('.custom-pre-order button[type="button"]');
    // console.log(event.detail);

    if (document.querySelector(".seletect-variant-id")) {
      document.querySelector(".seletect-variant-id").setAttribute("data-title", event.detail.variant.title);
    }
    RenderPreOrder(preOrderElement, preOrderButton);

  });

  document.addEventListener("facet:update", function (event) {
    //console.log("facet");
    setTimeout(function () {
      RenderTagLinks();
      RenderInfinteProduct();
    }, 1500);
    setTimeout(function () {
      RenderCollectionslider();
      RederSateches();
    }, 3000);
  });

  if (document.querySelector(".pdp-upsells")) {
 

    document.querySelectorAll(".upsell-img-slider").forEach((slider, index) => {
      const nextEl = slider.querySelector(".swiper-button-next");
      const prevEl = slider.querySelector(".swiper-button-prev");

      const options = {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        watchOverflow: true,
      };

      if (nextEl && prevEl) {
        options.navigation = {
          nextEl,
          prevEl,
        };
      }

      new Swiper(slider, options);
    });
  }
  //console.log('preOrderElement', preOrderElement);
  if (preOrderElement) {
    let preOrderButton = document.querySelector('.custom-pre-order button[type="button"]');

    RenderPreOrder(preOrderElement, preOrderButton);
  }
});

// Feature Fact Swiper JS
if (document.querySelector(".feature_fact_slider")) {
  var swiper = new Swiper(".feature_fact_slider", {
    slidesPerView: 1.2,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      576: {
        slidesPerView: 1.5,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2.4,
        spaceBetween: 10,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
    },
  });
  document.querySelector(".features_fact").removeAttribute("style");
}
if (document.querySelector(".upsell-img-slider")) {
  var swiper = new Swiper(".upsell-img-slider", {
    speed: 300,
    delay: 20,

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}
const showFeatureFacts = document.querySelectorAll(".show_ff_content");

if (showFeatureFacts) {
  showFeatureFacts.forEach((button) => {
    button.addEventListener("click", function () {
      button.parentNode.classList.toggle("active");
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const productSelect = document.querySelectorAll(".product_list_upsell");

  // Function to fetch product variants
  async function fetchProductVariants(productHandle) {
    try {
      // Shopify AJAX API endpoint to fetch product data
      const response = await fetch(`${productHandle}.js`);
      const product = await response.json();
      return product.variants;
    } catch (error) {
      console.error("Error fetching product variants:", error);
      return [];
    }
  }

  // Function to update variant dropdown
  function updateVariantDropdown(variants, variantSelectOption) {
    // Clear existing options
    const variantSelect = variantSelectOption.nextElementSibling;
    //console.log(variantSelect);
    if (!variantSelect) return; // Ensure the select element exists
    variantSelect.innerHTML = "";

    // Populate new options
    variants.forEach((variant) => {
      const option = document.createElement("option");
      option.value = variant.id;
      option.textContent = variant.title;
      if (!variant.available) {
        option.disabled = true;
        option.style.textDecoration = "line-through";
        option.textContent += " (sold out)";
      }
      variantSelect.appendChild(option);
    });
  }

  // Event listener for product selection change
  if (productSelect) {
    productSelect.forEach((select) => {
      select.addEventListener("change", async () => {
        const selectedProductHandle = select.value;
        if (selectedProductHandle) {
          const variants = await fetchProductVariants(selectedProductHandle);
          updateVariantDropdown(variants, select);
        }
      });
    });
  }

  document.addEventListener("recommendations:change", function (event) {
    //console.log("recommendations changed");
  });

  const custSwatches = document.querySelector(".cust_swatches");
  const dynamicColor = document.querySelector(".dynamic_color");

  if (custSwatches && dynamicColor) {
    const container = document.querySelector(".varient_info_wrapper"); // the wrapper around all swatches
    const items = Array.from(container.querySelectorAll(".product_swatch_box_container"));

    // sort by data-index (numerically)
    items.sort((a, b) => +a.dataset.index - +b.dataset.index);

    // re-append sorted elements to the DOM
    items.forEach((item) => container.appendChild(item));

    const swatchBoxes = custSwatches.querySelectorAll(".product_swatch_box_container");

    function updateActiveColor() {
      const active = custSwatches.querySelector(".product_swatch_box_container.activeslide");
      if (active) {
        const color = active.getAttribute("data-color");
        dynamicColor.textContent = color;
      }
    }

    // Run once on load
    updateActiveColor();

    swatchBoxes.forEach((box) => {
      box.addEventListener("mouseenter", () => {
        const hoverColor = box.getAttribute("data-color");
        if (hoverColor) {
          dynamicColor.textContent = hoverColor;
        }
      });

      box.addEventListener("mouseleave", () => {
        updateActiveColor();
      });
    });
  }

  if (document.querySelectorAll(".expandable_icon").length > 0) {
    document.querySelectorAll(".expandable_icon").forEach((icon) => {
      icon.addEventListener("click", function (event) {
        event.stopPropagation();

        this.classList.toggle("active");
        this.querySelector(".scale_text_container")?.classList.toggle("show");
      });

      // Simulate initial click
      icon.dispatchEvent(
        new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window,
        })
      );

      // Simulate click again after 9 seconds
      setTimeout(() => {
        icon.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
      }, 6000);
    });
  }
});

function RenderInfinteProduct() {
  const grid = document.querySelector(".product-list");
  const pagination = document.querySelector(".pagination");
  if (!grid || !pagination) return;

  let loading = false;
  let nextPageUrl = pagination.querySelector("a[rel='next']")?.href;

  // Hide normal pagination
  pagination.style.display = "none";

  // Create a small loader
  const loader = document.createElement("div");
  loader.id = "infinite-loader";
  loader.innerHTML = "<p>Loading more products...</p>";
  loader.style.textAlign = "center";
  loader.style.padding = "20px 0";
  loader.style.display = "none";
  grid.after(loader);

  const loadMoreProducts = () => {
    if (!nextPageUrl || loading) return;
    loading = true;
    loader.style.display = "block";

    fetch(nextPageUrl)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newProducts = doc.querySelector(".product-list");
        const newPagination = doc.querySelector(".pagination");

        if (newProducts) {
          grid.insertAdjacentHTML("beforeend", newProducts.innerHTML);
        }

        nextPageUrl = newPagination?.querySelector("a[rel='next']")?.href || null;
        loading = false;
        loader.style.display = "none";
        RenderCollectionslider();
        RederSateches();
      })
      .catch((err) => {
        console.error("Infinite scroll error:", err);
        loading = false;
        loader.style.display = "none";
      });
  };

  // Load more when user is near bottom (500–800px away)
  window.addEventListener("scroll", () => {
    if (!nextPageUrl || loading) return;

    const scrollPosition = window.innerHeight + window.scrollY;
    const threshold = document.body.offsetHeight - 2000; // start loading 800px before bottom

    if (scrollPosition >= threshold) {
      loadMoreProducts();
    }
  });
}
/* =====================================================
   CONFIG
===================================================== */
/* ============================
   MILESTONES
============================ */

const MILESTONES = [
  {goal: 140, key: "gift1"},
  {goal: 160, key: "gift2"},
  {goal: 200, key: "gift3"},
  {goal: 240, key: "gift4"},
  {goal: 280, key: 'gift5'}
];

/* ============================
   FREE GIFT PRODUCT IDS
============================ */

const FREE_GIFT_PRODUCT_IDS = ["ruffle-socks", "beanie", "tote-bag", "socks-2-pack", 'elevate-v-neck-sculpt-seamless-bra-midnight-navy-free-gift'];

function convertToEUR(amountInMinor) {
  if (Shopify?.currency?.rate) {
    return Number(amountInMinor) / 100 / Shopify.currency.rate;
  }
  return 0;
}

async function getCart() {
  const res = await fetch("/cart.js");
  return await res.json();
}

async function fetchProductById(productId) {
  const res = await fetch(`/products/${productId}.js`);
  return await res.json();
}

let FREE_GIFT_PRODUCTS = [];

async function loadFreeGiftProducts() {
  if (FREE_GIFT_PRODUCTS.length) return;

  for (const id of FREE_GIFT_PRODUCT_IDS) {
    const product = await fetchProductById(id);
    FREE_GIFT_PRODUCTS.push(product);
  }
}

function getReachedMilestones(spentInEUR) {
  return MILESTONES.filter((m) => spentInEUR >= m.goal);
}

function getGiftForMilestone(cart, milestoneKey) {
  return cart.items.find((item) => item.properties?._free_gift === "true" && item.properties?._milestone === milestoneKey);
}

function updateMilestoneUI(spentInEUR) {
  const banner = document.getElementById("free-shipping-banner");
  if (!banner) return;

  for (let i = 0; i < MILESTONES.length; i++) {
    if (spentInEUR < MILESTONES[i].goal) {
      const remaining = (MILESTONES[i].goal - spentInEUR) * Shopify.currency.rate;
      if(MILESTONES[i].key == "gift5")
      {
        banner.innerHTML = `Spend ${remaining.toFixed(2)} ${Shopify.currency.active} more to get a <b>FREE BRA</b>`;
      } 
      else{
        banner.innerHTML = `Spend ${remaining.toFixed(2)} ${Shopify.currency.active} more to get a <b>FREE GIFT</b>`;
      }
      return;
    }
  }

  banner.innerHTML = `<b>All Free Gifts Unlocked 🎁</b>`;
}

function calculateSegmentedProgress(spentInEUR) {
  const totalSegments = MILESTONES.length;
  let progressPercent = 0;

  for (let i = 0; i < MILESTONES.length; i++) {
    const prevGoal = i === 0 ? 0 : MILESTONES[i - 1].goal;
    const currGoal = MILESTONES[i].goal;

    if (spentInEUR >= currGoal) {
      // Full segment filled
      progressPercent += 100 / totalSegments;
    } else if (spentInEUR > prevGoal) {
      // Partial fill in this segment
      const segmentProgress =
        (spentInEUR - prevGoal) / (currGoal - prevGoal);

      progressPercent += segmentProgress * (100 / totalSegments);
      break;
    } else {
      break;
    }
  }

  return Math.min(progressPercent, 100);
}



function updateProgressBar(spentInEUR) {
  const progress = calculateSegmentedProgress(spentInEUR);

  document
    .querySelector(".milestone-line-inner")
    ?.style.setProperty("--progress", progress + "%");

  MILESTONES.forEach((m) => {
    const dot = document.querySelector(`.Euromilestore_${m.key}`);
    if (!dot) return;

    spentInEUR >= m.goal
      ? dot.classList.add("reached")
      : dot.classList.remove("reached");
  });
}


async function removeInvalidGifts(cart, spentInEUR) {
  for (const m of MILESTONES) {
    if (spentInEUR < m.goal) {
      const gift = getGiftForMilestone(cart, m.key);
      if (gift) {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: {"Content-Type": "application/json"},
          body: JSON.stringify({id: gift.key, quantity: 0}),
        });
        window.location.reload();
      }
    }
  }
}

let activeMilestoneKey = null;
let selectedVariantId = null;

async function renderFreeGiftPopup(milestoneKey) {
  activeMilestoneKey = milestoneKey;
  selectedVariantId = null;

  await loadFreeGiftProducts();

  const popup = document.getElementById("free-gift-popup");
  const list = popup.querySelector(".free-gift-list");
  const addBtn = document.getElementById("add-free-gift-btn");

  list.innerHTML = "";
  addBtn.disabled = true;

  FREE_GIFT_PRODUCTS.forEach((product, index) => {
    console.log(activeMilestoneKey+" != gift5 && "+index+" == 4");
     if(activeMilestoneKey != "gift5" && index == 4) return;
    const item = document.createElement("div");
    item.className = "free-gift-item";

    const radio = document.createElement("input");
    radio.type = "radio";
    radio.name = "free-gift";

    const img = document.createElement("img");
    img.src = product.featured_image + "&width=70";

    const imgDiv = document.createElement("div");
    imgDiv.className = "free-image";
    imgDiv.appendChild(img);

    const title = document.createElement("strong");
    title.innerText = product.title;

    const price = document.createElement("span");
    price.innerText = "Free";
    price.className = "free-label";

    const midDiv = document.createElement("div");
    midDiv.className = "free-midblock";
    midDiv.append(title, price);

    let variantSelect = null;

    if (product.variants.length > 1) {
      variantSelect = document.createElement("select");
      variantSelect.disabled = true;

      product.variants.forEach((v) => {
        const opt = document.createElement("option");
        opt.value = v.id;
        opt.innerText = v.title;
        opt.disabled = !v.available;
        variantSelect.appendChild(opt);
      });

      variantSelect.addEventListener("change", () => {
        selectedVariantId = variantSelect.value;

         const giftvarintID = document.getElementById("add-free-gift-id");
  if (giftvarintID) {
    giftvarintID.value = selectedVariantId;
  }
  const gift__milestone = document.getElementById("gift__milestone");
  if (gift__milestone) {
    gift__milestone.value = activeMilestoneKey;
  }
      });
    } else {
      selectedVariantId = product.variants[0].id;
    }

    radio.addEventListener("change", () => {
      document.querySelectorAll(".free-gift-item select").forEach((s) => s && (s.disabled = true));

      if (variantSelect) {
        variantSelect.disabled = false;
        selectedVariantId = variantSelect.value;
      } else {
        selectedVariantId = product.variants[0].id;
      }
      console.log("selectedVariantId in", selectedVariantId);
      addBtn.disabled = false;

       const giftvarintID = document.getElementById("add-free-gift-id");
  if (giftvarintID) {
    giftvarintID.value = selectedVariantId;
  }
  const gift__milestone = document.getElementById("gift__milestone");
  if (gift__milestone) {
    gift__milestone.value = activeMilestoneKey;
  }


    });
    const radioDiv = document.createElement("div");
    radioDiv.className = "free-radio";
    radioDiv.appendChild(radio);
    if (variantSelect) midDiv.appendChild(variantSelect);

    item.append(imgDiv, midDiv, radioDiv);

    list.appendChild(item);
  });

  popup.classList.add("show");
}
  console.log("activeMilestoneKey", activeMilestoneKey);

document.getElementById("add-free-gift-btn").addEventListener("click", async () => {
    console.log("selectedVariantId", selectedVariantId);
      console.log("activeMilestoneKey", activeMilestoneKey);
  if (!selectedVariantId || !activeMilestoneKey) return;


  const giftvarintID = document.getElementById("add-free-gift-id");
  if (giftvarintID) {
    giftvarintID.value = selectedVariantId;
  }
  const gift__milestone = document.getElementById("gift__milestone");
  if (gift__milestone) {
    gift__milestone.value = activeMilestoneKey;
  }


  /*
  const originSubmitButton = document.getElementById("add-free-gift-btn-orignal");
if (originSubmitButton && originSubmitButton.form) {
  originSubmitButton.form.requestSubmit();
}*/


  closeFreeGiftPopup();

});

function openFreeGiftPopup(milestoneKey) {

 
 
  renderFreeGiftPopup(milestoneKey);
}


function positionMilestoneDots() {
    console.log("positionMilestoneDots");

  const total = MILESTONES.length;

  MILESTONES.forEach((m, index) => {
     console.log("positionMilestoneDots key", m.key);
    const dot = document.querySelector(`.Euromilestore_${m.key}`);
   // console.log("dot", dot);
    if (!dot) return;

    // 20%, 40%, 60%, 80%
    const leftPercent = ((index + 1) / total) * 100;

    dot.style.left = `${leftPercent}%`;
    dot.style.transform = "translateX(-50%)";
  });
}


function closeFreeGiftPopup() {
  document.getElementById("free-gift-popup")?.classList.remove("show");
}

async function handleMilestones() {
  const banner = document.getElementById("free-shipping-banner");
  if (!banner) return;

  const spentInEUR = convertToEUR(banner.dataset.total);

  updateMilestoneUI(spentInEUR);
  updateProgressBar(spentInEUR);

  if (document.body.classList.contains("cartupdating")) return;
  document.body.classList.add("cartupdating");

  try {
    const cart = await getCart();

    await removeInvalidGifts(cart, spentInEUR);

    const pending = getReachedMilestones(spentInEUR).find((m) => !getGiftForMilestone(cart, m.key));

    if (pending) {
      openFreeGiftPopup(pending.key);
    }
  } finally {
    setTimeout(() => {
      document.body.classList.remove("cartupdating");
    }, 1500);
  }
}

document.addEventListener("DOMContentLoaded",() => {
   handleMilestones();
    positionMilestoneDots();
     RenderInfinteProduct?.();
  });

document.addEventListener("cart:change", () => {
  setTimeout(handleMilestones, 1200);
  setTimeout(positionMilestoneDots, 1500);
  
});
